export const notificationTypeEnum = {
  UPDATE_PROFILE: 'update_profile',
  ACHIEVEMENT: 'achievement',
  ACHIEVEMENT_LEVEL: 'achievement_level',
  ACHIEVEMENT_NEXT: 'achievement_next',
  BONUS_GAME_POINTS: 'bonus_game_points',
  BONUS_BUNDLE_DISCOUNT: 'bonus_bundle_discount',
  INVITATION_REGISTRATION: 'invitation_registration',
  ADD_ON_GAME_LANTERNS: 'add_on_game_lanterns',
  ADD_ON_GAME_PUZZLE: 'add_on_game_puzzle',
}

export const notificationDescriptionTextTypeEnum = {
  TRANSLATION_KEY: 'translationKey',
  DYNAMIC_VALUE: 'dynamicValue'
}

export const notificationConfigurationPerType = {
  [notificationTypeEnum.UPDATE_PROFILE]: {
    getTitle: () => 'notification_page_notification_update_profile_title',
    getDescriptionAsList: () => [{type: notificationDescriptionTextTypeEnum.TRANSLATION_KEY, value: 'notification_page_notification_update_profile_description'}],
    getIcon: () => ({notificationIconSrc: '/static/images/notifications/profile_icon.png', notificationIconAlt: ''})
  },
  [notificationTypeEnum.ACHIEVEMENT]: {
    getTitle: () => 'notification_page_notification_achievement_title',
    getDescriptionAsList: ({rewardPoints}) => [
      {type: notificationDescriptionTextTypeEnum.TRANSLATION_KEY, value: 'notification_page_notification_achievement_description_pt1'},
      {type: notificationDescriptionTextTypeEnum.DYNAMIC_VALUE, value: rewardPoints},
      {type: notificationDescriptionTextTypeEnum.TRANSLATION_KEY, value: 'notification_page_notification_achievement_description_pt2'}
    ],
    getIcon: ({achievementName}) => ({notificationIconSrc: `/static/images/achievements/${achievementName}_unlocked.png`, notificationIconAlt: ''})
  },
  [notificationTypeEnum.ACHIEVEMENT_LEVEL]: {
    getTitle: ({level}) => ({
      1: 'notification_page_notification_achievement_level_1_title',
      2: 'notification_page_notification_achievement_level_2_title',
      3: 'notification_page_notification_achievement_level_3_title',
      4: 'notification_page_notification_achievement_level_4_title'
    }[level] || ''),
    getDescriptionAsList: ({rewardPoints}) => [
      {type: notificationDescriptionTextTypeEnum.TRANSLATION_KEY, value: 'notification_page_notification_achievement_level_description_pt1'},
      {type: notificationDescriptionTextTypeEnum.DYNAMIC_VALUE, value: rewardPoints},
      {type: notificationDescriptionTextTypeEnum.TRANSLATION_KEY, value: 'notification_page_notification_achievement_level_description_pt2'}
    ],
    getIcon: ({level}) => ({notificationIconSrc: `/static/images/notifications/lvl${level}_icon.png`, notificationIconAlt: ''})
  },
  [notificationTypeEnum.ACHIEVEMENT_NEXT]: {
    getTitle: () => 'notification_page_notification_achievement_next_title',
    getDescriptionAsList: ({rewardPoints}) => [
      {type: notificationDescriptionTextTypeEnum.TRANSLATION_KEY, value: 'notification_page_notification_achievement_next_description_pt1'},
      {type: notificationDescriptionTextTypeEnum.DYNAMIC_VALUE, value: rewardPoints},
      {type: notificationDescriptionTextTypeEnum.TRANSLATION_KEY, value: 'notification_page_notification_achievement_next_description_pt2'}
    ],
    getIcon: () => null
  },
  [notificationTypeEnum.BONUS_GAME_POINTS]: {
    getTitle: () => 'notification_page_notification_bonus_game_points_title',
    getDescriptionAsList: ({duration, multiplier}) => (multiplier < 2 || multiplier > 4)
      ? []
      : [
        {type: notificationDescriptionTextTypeEnum.TRANSLATION_KEY, value: 'notification_page_notification_bonus_game_points_description_pt1'},
        {type: notificationDescriptionTextTypeEnum.DYNAMIC_VALUE, value: duration},
        {
          type: notificationDescriptionTextTypeEnum.TRANSLATION_KEY,
          value: duration === 1 ? 'notification_page_notification_bonus_game_points_description_pt2' : 'notification_page_notification_bonus_game_points_description_pt2_plural'
        },
        {
          type: notificationDescriptionTextTypeEnum.TRANSLATION_KEY,
          value: `notification_page_notification_bonus_game_points_description_pt3_x${multiplier}`
        }
      ],
    getIcon: ({multiplier}) => ({notificationIconSrc: `/static/images/x${multiplier}.svg`, notificationIconAlt: ''})
  },
  [notificationTypeEnum.BONUS_BUNDLE_DISCOUNT]: {
    getTitle: () => 'notification_page_notification_bonus_bundle_discount_title',
    getDescriptionAsList: ({duration, multiplier}) => (multiplier < 2 || multiplier > 4)
      ? []
      : [
        {type: notificationDescriptionTextTypeEnum.TRANSLATION_KEY, value: 'notification_page_notification_bonus_bundle_discount_description_pt1'},
        {type: notificationDescriptionTextTypeEnum.DYNAMIC_VALUE, value: duration},
        {
          type: notificationDescriptionTextTypeEnum.TRANSLATION_KEY,
          value: duration === 1 ? 'notification_page_notification_bonus_bundle_discount_description_pt2' : 'notification_page_notification_bonus_bundle_discount_description_pt2_plural'
        },
        {
          type: notificationDescriptionTextTypeEnum.TRANSLATION_KEY,
          value: `notification_page_notification_bonus_bundle_discount_description_pt3_x${multiplier}`
        }
      ],
    getIcon: () => ({notificationIconSrc: '/static/images/discount.svg', notificationIconAlt: ''})
  },
  [notificationTypeEnum.INVITATION_REGISTRATION]: {
    getTitle: () => 'notification_page_notification_invitation_registration_title',
    getDescriptionAsList: ({rewardPoints}) => [
      {type: notificationDescriptionTextTypeEnum.TRANSLATION_KEY, value: 'notification_page_notification_invitation_registration_description_pt1'},
      {type: notificationDescriptionTextTypeEnum.DYNAMIC_VALUE, value: rewardPoints},
      {type: notificationDescriptionTextTypeEnum.TRANSLATION_KEY, value: 'notification_page_notification_invitation_registration_description_pt2'}
    ],
    getIcon: () => ({notificationIconSrc: '/static/images/notifications/friend_icon.png', notificationIconAlt: ''})
  },
  [notificationTypeEnum.ADD_ON_GAME_LANTERNS]: {
    getTitle: () => 'notification_page_notification_game_lanterns_title',
    getDescriptionAsList: () => [{type: notificationDescriptionTextTypeEnum.TRANSLATION_KEY, value: 'notification_page_notification_game_lanterns_description'}],
    getIcon: () => ({notificationIconSrc: '/static/images/notifications/lanterns.svg', notificationIconAlt: ''})
  },
  [notificationTypeEnum.ADD_ON_GAME_PUZZLE]: {
    getTitle: () => 'notification_page_notification_game_puzzle_title',
    getDescriptionAsList: () => [{type: notificationDescriptionTextTypeEnum.TRANSLATION_KEY, value: 'notification_page_notification_game_puzzle_description'}],
    getIcon: () => ({notificationIconSrc: '/static/images/notifications/puzzle.svg', notificationIconAlt: ''})
  },
}



// WEBPACK FOOTER //
// ./src/constants/notification.js